import PropTypes from 'prop-types';
import colors from '../../util/colors.js';

var Variants;
(function (Variants) {
    Variants["RECT"] = "rect";
    Variants["CIRCLE"] = "circle";
    Variants["TEXT"] = "text";
})(Variants || (Variants = {}));
var SchemaDirectionVariants;
(function (SchemaDirectionVariants) {
    SchemaDirectionVariants["COLUMN"] = "column";
    SchemaDirectionVariants["ROW"] = "row";
})(SchemaDirectionVariants || (SchemaDirectionVariants = {}));
var propTypes = {
    variant: PropTypes.string,
    count: PropTypes.number,
    schema: PropTypes.arrayOf(PropTypes.object),
    schemaDirection: PropTypes.string,
    lineClassName: PropTypes.string,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
    'aria-busy': PropTypes.bool,
    'aria-live': PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    isLoading: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    circle: PropTypes.bool,
    color: PropTypes.string,
    baseColor: PropTypes.string,
    highlightColor: PropTypes.string,
    direction: PropTypes.string,
    enableAnimation: PropTypes.bool,
    duration: PropTypes.number,
    style: PropTypes.object,
};
var defaultProps = {
    variant: Variants.RECT,
    count: 1,
    color: colors.base20,
    children: null,
    isLoading: true,
    enableAnimation: true,
    'aria-busy': true,
    'aria-live': 'polite',
};

export { SchemaDirectionVariants, Variants, defaultProps, propTypes };
